// extracted by mini-css-extract-plugin
export default {"container":"logo_container__fkYf5","logo_bg":"logo_logo_bg__YPE7E","logo_letter":"logo_logo_letter__uw92i"};